import { CFOccurrence } from '@scentregroup/shared/types/contentful'

import { CentreTime } from '../use-centre-time'
import { type EventContentDetail } from '../get-event-details'
import { DateTime, isBeforeNow } from '../date-helpers'

export type Occurrences = {
  summary: boolean
  timeZone: CentreTime | null
  times: Pick<CFOccurrence, 'startAt' | 'endAt'>[]
  pastTimes?: Pick<CFOccurrence, 'startAt' | 'endAt'>[]
}

const isValidateOccurrence = (startAt: string, endAt: string): boolean =>
  DateTime.fromISO(startAt, {}) < DateTime.fromISO(endAt, {})

const validateOccurrences = (
  occurrences: EventContentDetail['occurrences'],
  isPastEvents = false
): Pick<CFOccurrence, 'startAt' | 'endAt'>[] =>
  occurrences.filter(occurrence =>
    isPastEvents
      ? isBeforeNow(occurrence.endAt) &&
        isValidateOccurrence(occurrence.startAt, occurrence.endAt)
      : !isBeforeNow(occurrence.endAt) &&
        isValidateOccurrence(occurrence.startAt, occurrence.endAt)
  )

export const getOccurrences = (
  isSummary: boolean,
  entry: EventContentDetail | undefined,
  timeZone: CentreTime | null
): Occurrences | null => {
  if (!entry) {
    return null
  }

  const { startAt, endAt, hideAt, occurrences } = entry
  const end = endAt || hideAt

  let normalisedOccurrences: EventContentDetail['occurrences']
  if (occurrences && occurrences.length) {
    normalisedOccurrences = [...occurrences]
  } else if (startAt && end && isValidateOccurrence(startAt, end)) {
    normalisedOccurrences = [
      {
        startAt,
        endAt: end,
      },
    ]
  } else {
    return null
  }

  const currentTimes = validateOccurrences(normalisedOccurrences)
  const pastTimes = validateOccurrences(normalisedOccurrences, true)
  const result = { summary: isSummary, times: currentTimes, timeZone }

  if (isSummary) {
    return result
  } else {
    return {
      ...result,
      pastTimes,
      times: currentTimes,
    }
  }
}
